import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-surface text-button-text shadow hover:bg-surface/90 dark:bg-surface dark:text-button-text dark:hover:bg-surface/90",
        destructive:
          "bg-error text-button-text shadow-sm hover:bg-error/90 dark:bg-error dark:text-button-text dark:hover:bg-error/90",
        outline:
          "border border-surface-border bg-surface shadow-sm hover:bg-surface-hover hover:text-text-primary dark:border-surface-border dark:bg-surface dark:hover:bg-surface-hover dark:hover:text-text-primary",
        secondary:
          "bg-surface text-text-primary shadow-sm hover:bg-surface/80 dark:bg-surface dark:text-button-text dark:hover:bg-surface/80",
        ghost:
          "hover:bg-surface-hover hover:text-text-primary dark:hover:bg-surface-hover dark:hover:text-text-primary",
        link: "text-text-primary underline-offset-4 hover:underline dark:text-button-text",
      },
      size: {
        default: "h-8 px-4 py-2",
        sm: "h-7 rounded-md px-3 text-xs",
        lg: "h-9 rounded-md px-8",
        icon: "h-8 w-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
